<template lang="pug">
  validation-observer(ref='validation' tag='form', v-if="processo.id")
    app-modal-selecionar-modelo-notificacao(
      :tiposModelo="tiposModelo",
      titulo="Modelos de Despacho",
      v-if="showModalDespacho",
      :showModal="showModalDespacho"
      @closeModal="fecharModalDespacho",
      @setTextoDespacho="setTextoDespacho"
    )
    el-card(shadow='hover').card-collapse
      el-row.margin-medium-top(:gutter="20")
        el-col(:span='8').center
          app-display(label="Nome do Interessado:", :content="processo.nomeRazaoSocialInteressado")
          app-display(label="Número do processo:", :content="processo.numeroProcesso")
        el-col(:span='8')
          app-display(label="CPF do Interessado:", :content="processo.cpfCnpjInteressado")
          app-display(label="Tipo de Processo:", :content="processo.tipo")
        app-opcoes-header-analise.right(
          :idProcesso="processo.id",
          :numeroProcesso="processo.numeroProcesso",
          :tipoProcesso="processo.tipo.codigo",
          :protocolo="processo.numeroProtocolo",
          :btnSolicitarInformacao="false",
          :btnRetificacao="false")
    el-card(shadow="hover").card-collapse
      .radios-despacho-parecer
        validation-provider(rules="required", v-slot="{ errors }")
          .container-buttons
            el-radio-group(
              v-model="isGerarCustas",
              name="parecer",
            )
              div.padding.input(:class="{'erro' : errors.length}")
                el-radio(:label="true", :border="true") Gerar custas agrárias
                el-radio(:label="false", :border="true") Despacho
            span.help.erro {{ errors[0] }}
    el-card(shadow='hover').card-collapse
      app-geracao-custas(
        :custa="custa",
        :valoresFixos="valoresFixos"
        :exibirLabelCustas="false",
        :exibirNumeroModulos="true",
        :exibirFatorLocalizacao="false",
        :exibirElaboracaoPublicacao="true",
        :credenciadoVistoria="processo.credenciadoVistoria",
        :credenciadoGeomensor="processo.credenciadoGEO"
        :processo="processo"
        v-if="isGerarCustas === true"
      )
      div(v-else)
        validation-provider(rules="required", v-slot="{ errors }")
          .flex-despacho
            p.label Despacho
              span.required &nbsp * &nbsp
            el-button(type="primary", @click="openModalDespacho") Modelo &nbsp
              .fa.fa-file

          app-editor-texto.input(
            @onTextChange="onTextChange",
            v-model="textoDespacho",
            :class="{'erro' : errors.length}"
            ref="editorTexto"
          )
          span.help.erro {{ errors[0] }}
        app-anexo(
          :id="'upload-anexo-despacho'",
          @uploadFile="uploadFile",
          :files="anexos",
          @removeFile="removeFile"
          @downloadDocumentoCadastro="downloadDocumentoCadastro",
          :tipoExibir="'ANEXO_ANALISE'"
        )
        app-radios-tramitacao(
          :radios="acoesRadio",
          :isDecisao="isDecisao",
          @changeRadio="changeRadio",
          :radioInicial="null",
        )
      el-row
          div.buttons
            el-button.btn(
              type="default"
              @click="cancelar"
            )
              i.fa.fa-times
              | &nbsp Cancelar
            el-button.btn(
              type="success",
              @click="finalizar"
            )
              i.fa.fa-chevron-right
              | &nbsp Finalizar
</template>
<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import utils from '@/utils/utils'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import AppDisplay from '@/components/AppDisplay'
import AppDoubleInput from '@/components/AppDoubleInput'
import AppDiariasCustas from './components/AppDiariasCustas'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppOpcoesHeaderAnalise from './components/modal/AppOpcoesHeaderAnalise'
import AppGeracaoCustas from '@/components/AppGeracaoCustas'
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppAnexo from '@/components/AppAnexo'
import AppModalSelecionarModeloNotificacao from './components/AppModalSelecionarModeloNotificacao'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
const { tiposModeloDefault } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppOpcoesHeaderAnalise,
    AppDiariasCustas,
    AppDoubleInput,
    AppDisplay,
    AppDivider,
    AppLabel,
    AppGeracaoCustas,
    AppEditorTexto,
    AppAnexo,
    AppModalSelecionarModeloNotificacao,
    AppRadiosTramitacao
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idProcesso: {
      required: true
    },
    acaoCaixa: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      processo: {
        tipo: {
        }
      },
      valoresFixos: [],
      custa: {
        numeroDiarias: 0,
        numeroModulos: 0,
        valorMotorista: {
          quantidade: 1,
          total: 0,
          valor: 0
        },
        valorVistoria: {
          quantidade: 1,
          total: 0,
          valor: 0
        },
        valorDemarcacao: {
          quantidade: 1,
          total: 0,
          valor: 0
        },
        dataVencimento: new Date()
      },
      isGerarCustas: true,
      textoDespacho: '',
      anexos: [],
      showModalDespacho: false,
      acao: null,
      acoesRadio: [],
      tiposModelo: tiposModeloDefault
    }
  },

  async created () {
    this.processo = await this.findProcessoCalculoCusta(this.idProcesso)
    let radios = await this.tarefa({ processo: this.idProcesso })
    this.acoesRadio = radios.acoes.filter(acao => acao.valor.includes('ARQUIVAMENTO.SISTEMA.SISTEMA.AUTOCOMPLETE') || acao.valor.includes('RETORNO.SISTEMA.ANTERIOR'))
    this.valoresFixos = await this.getCustasAgrarias()
    this.custa.numeroDiarias = await this.getNumeroDiarias(this.idProcesso)
    this.custa.numeroModulos = await this.getNumeroModulos(this.processo.numeroProtocolo)
    let hoje = new Date()
    this.custa.dataVencimento = hoje.setDate(hoje.getDate() + 15)
    this.diariaMotorista()
    this.diariaVistoria()
    this.diariaDemarcacao()
  },

  computed: {
    totalMotoristaPorFuncionario () {
      return this.totalPorFuncionario('valorMotorista')
    },
    totalMotorista () {
      return this.totalPessoal('valorMotorista')
    },
    totalVistoriaPorFuncionario () {
      return this.totalPorFuncionario('valorVistoria')
    },
    totalVistoria () {
      return this.totalPessoal('valorVistoria')
    },
    totalDemarcacaoPorFuncionario () {
      return this.totalPorFuncionario('valorDemarcacao')
    },
    totalDemarcacao () {
      return this.totalPessoal('valorDemarcacao')
    },
    valorFixoEditalAlienacaoPublica () {
      const valorFixo = _.find(this.valoresFixos, ['codigo', 'ELABORACAO_EDITAL'])
      return (valorFixo ? valorFixo.valor : 0) * this.custa.numeroModulos
    },
    valorFixoEditalAlienacaoPublicaFormatado () {
      return ` R$ ${utils.format(this.valorFixoEditalAlienacaoPublica)}`
    },
    valorTotal () {
      const valorTotal = this.custa.valorMotorista.total +
        this.custa.valorVistoria.total +
        this.custa.valorDemarcacao.total +
        this.valorFixoEditalAlienacaoPublica
      return valorTotal
    },
    valorTotalCustas () {
      return `R$ ${utils.format(this.valorTotal)}`
    }
  },

  methods: {
    ...mapActions({
      findProcessoCalculoCusta: 'processo/findProcessoCalculoCusta',
      getCustasAgrarias: 'custas/getCustasAgrarias',
      getNumeroDiarias: 'custas/getNumeroDiarias',
      getNumeroModulos: 'custas/getNumeroModulos',
      arquivarProcesso: 'processo/arquivarProcesso',
      retornarSetor: 'processo/retornarSetor',
      tarefa: 'processo/tarefa',
      finalisar: 'custas/finalisar'
    }),

    totalPorFuncionario (tipo) {
      const result = this.custa.numeroDiarias * this.custa[tipo].valor
      return `R$ ${utils.format(result)}`
    },

    changeRadio (value) {
      this.acao = value.acao
    },

    totalPessoal (tipo) {
      const total = this.custa[tipo].valor * this.custa[tipo].quantidade
      this.custa[tipo].total = this.custa.numeroDiarias * total
      return `R$ ${utils.format(this.custa[tipo].total)}`
    },

    diariaMotorista () {
      this.diaria('valorMotorista', 'DIARIA_MOTORISTA')
    },

    diariaVistoria () {
      this.diaria('valorVistoria', 'DIARIA_VISTORIA')
    },

    diariaDemarcacao () {
      this.diaria('valorDemarcacao', 'DIARIA_DEMARCACAO_FISCALIZACAO')
    },

    diaria (tipo, codigo) {
      const valorFixo = _.find(this.valoresFixos, ['codigo', codigo])
      this.custa[tipo].valor = valorFixo ? valorFixo.valor : 0
    },

    cancelar () {
      this.confirmBox(this.$messages.CANCELAR_EMISSAO_CUSTA, this.$messages.TITULO_WARNING,
        () => {
          this.$router.back()
        },
        () => { })
    },

    fecharModalDespacho () {
      this.showModalDespacho = false
    },
    setTextoDespacho (textoDespacho) {
      this.$refs.editorTexto.text = textoDespacho
      this.$refs.editorTexto.emitTextChange()
    },

    async finalizar () {
      const valido = await this.$refs.validation.validate()
      if (valido) {
        if (this.isGerarCustas === true) {
          this.confirmBox(this.$messages.CONFIRM_CUSTA, this.$messages.TITULO_WARNING,
            () => {
              this.custa.totalEditalAlienacaoPublica = this.valorFixoEditalAlienacaoPublica
              this.custa.valorTotal = this.valorTotal
              this.custa.processo = {
                id: this.processo.id
              }
              this.finalisar(this.custa).then(() => {
                this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.CUSTA_GERADA)
                this.$router.push({
                  name: 'AGUARDANDO_CALCULO_CUSTAS'
                })
              })
            },
            () => { })
        } else if (this.isGerarCustas === false) {
          this.confirmBox(this.$messages.FINALIZAR_ANALISE, this.$messages.TITULO_WARNING,
            async () => {
              try {
                let despacho = {
                  idProcesso: this.processo.id,
                  acao: this.acao,
                  textoDespacho: this.textoDespacho,
                  anexos: this.anexos
                }

                this.arquivarProcesso(despacho)
                  .then(() => {
                    this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
                      this.acao.includes('RETORNO') ? 'Processo retornado ao setor anterior.' : 'Arquivamento de processo solicitado')
                    this.$router.push({
                      name: 'AGUARDANDO_CALCULO_CUSTAS'
                    })
                  })
              } catch (error) {
                const erroValidacao = error.status === 422
                const tipoErro = !erroValidacao ? this.$messages.TIPO_ERROR : this.$messages.TIPO_WARNING
                const tituloErro = !erroValidacao ? this.$messages.TITULO_ERROR : this.$messages.TITULO_WARNING
                const messagemDeErro = Array.isArray(error.erros) ? error.erros.join(';') : 'Houve um erro ao salvar a analise.'
                this.showNotificacao(tipoErro, tituloErro, messagemDeErro)
              }
            })
        }
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS)
      }
    },

    openModalDespacho () {
      this.showModalDespacho = true
    },

    onTextChange (text) {
      this.textoDespacho = text
    },

    async removeFile (documento) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => { })
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },
    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },

    uploadFile (file) {
      this.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.buttons {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.margin-medium-top {
  margin-top: 20px;
}

.totalLabel {
  padding: 10px;
}

.right {
  float: right;
}

.body-component {
  padding-top: 20px;
}

.label-diaria {
  display: inline-block;
  padding-right: 10px;
  font-weight: bold;
}

.label-funcionarios {
  padding-top: 8px;
  margin: 2px 2px 2px 2px;
  font-weight: bold;
}

.flex-despacho {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
}

.radios-despacho-parecer {
  display: flex;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/GerarCustas.vue